export type TemperatureZone = 'frozen' | 'refrigerated' | 'ambient';

export interface TemperatureZoneOption {
  value: TemperatureZone;
  label: string;
}

// Ordered coldest → warmest for display. Ambient is the app-wide default when
// neither a stock item nor its store specifies a zone.
export const TEMPERATURE_ZONES: TemperatureZoneOption[] = [
  {value: 'frozen', label: 'Freezer'},
  {value: 'refrigerated', label: 'Fridge'},
  {value: 'ambient', label: 'Room temperature'},
];

export const DEFAULT_TEMPERATURE_ZONE: TemperatureZone = 'ambient';
